export const PAYMENT_ENDPOINT = {
  detail: `${import.meta.env.VITE_APP_API}/payments/get-payment`,
  list: `${import.meta.env.VITE_APP_API}/payments/get-payments`,
  getOwnersOfPayment: `${import.meta.env.VITE_APP_API}/owners/get-owners`,
  archive: `${import.meta.env.VITE_APP_API}/payments/archive-payment`,
  delete: `${import.meta.env.VITE_APP_API}/payments/delete-payment`,
  changePaymentStatus: `${
    import.meta.env.VITE_APP_API
  }/payments/change-payment-status`,
  updateFsNumber: `${import.meta.env.VITE_APP_API}/payments/update-fs-number`,
  restore: `${import.meta.env.VITE_APP_API}/payments/restore-payment`,
  archivedPayments: `${
    import.meta.env.VITE_APP_API
  }/payments/get-archived-payments`,
  archivedPayment: `${
    import.meta.env.VITE_APP_API
  }/payments/get-archived-payment`,
  create: `${import.meta.env.VITE_APP_API}/payments/create-payment`,
  update: `${import.meta.env.VITE_APP_API}/payments/update-payment`,
  updateProfile: `${
    import.meta.env.VITE_APP_API
  }/payments/update-payment-profile-image/`,

  export: `${import.meta.env.VITE_APP_API}/payments/export-payments`,
  import: `${import.meta.env.VITE_APP_API}/payments/import-payments`,
}
